import { localStorage } from 'dibs-browser-storage';
import { graphql } from 'react-relay/legacy.js';

import { getLocalRecentHistoryList } from './getLocalRecentHistory.ts';
import { RECENT_HISTORY_COUNT, RECENT_HISTORY_LIST } from './recentHistoryConstants.ts';

// types
import { type addLocalRecentHistory_item$data as RecentHistoryItemType } from './__generated__/addLocalRecentHistory_item.graphql.ts';
import { type LocalHistoryItemType } from './recentHistoryTypes.ts';

//TODO: convert to relay hook or use readInlineData instead of disabling relay mask. With current approach it's difficult to maintain types
export const addLocalRecentHistoryItem = ({
    contemporaryTrackingString,
    firstPhotoWebPath,
    pdpURL,
    title,
    browseUrl,
    categoryCode,
    serviceId,
    categoryPath,
    seller,
    isComplete,
    isListingListed,
}: RecentHistoryItemType): void => {
    /**
     * Add only available items to local storage.
     */
    if (isComplete && isListingListed) {
        const currentDate = new Date();
        const currentItem: LocalHistoryItemType = {
            contemporaryTrackingString,
            itemTitle: title || document.title,
            itemId: serviceId || '',
            itemImageUrl: firstPhotoWebPath || '',
            itemPdpUrl: pdpURL || '',
            itemBrowseUrl: browseUrl,
            itemCategoryCode: categoryCode,
            dealerPk: seller?.serviceId || '',
            category: categoryPath,
            timestamp: currentDate.getTime().toString(),
        };

        const localRecentHistoryList = getLocalRecentHistoryList([currentItem.itemId]) || [];

        localRecentHistoryList.push(currentItem);

        localStorage.setItem(RECENT_HISTORY_COUNT, localRecentHistoryList.length);
        localStorage.setItem(RECENT_HISTORY_LIST, JSON.stringify(localRecentHistoryList));
    }
};

export const itemFragment = {
    item: graphql`
        fragment addLocalRecentHistory_item on Item {
            contemporaryTrackingString
            firstPhotoWebPath(size: small)
            pdpURL
            title
            browseUrl
            categoryCode
            serviceId
            categoryPath
            seller {
                serviceId
            }
            isComplete
            isListingListed
        }
    `,
};
